import React from 'react';
import { Menu } from '../components/Menu';
export function MenuPage() {
  return <div className="pt-24 md:pt-28" data-id="element-349">
      <Menu data-id="element-350" />
    </div>;
}